import { useState } from 'react';

export default function ProgressPanel() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-100 overflow-hidden">
      {/* Header */}
      <div className="px-3 py-2 bg-white/50 border-b border-blue-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-blue-500 rounded-lg flex items-center justify-center">
            <i className="ri-brain-line text-white text-sm"></i>
          </div>
          <span className="text-xs font-semibold text-gray-900">深度思考过程</span>
        </div>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="px-2 py-1 flex items-center gap-1 hover:bg-white/50 rounded-lg transition-colors cursor-pointer"
        >
          <span className="text-xs text-blue-600 font-medium">{isExpanded ? '收起' : '展开'}</span>
          <i className={`ri-arrow-${isExpanded ? 'up' : 'down'}-s-line text-blue-600 text-sm`}></i>
        </button>
      </div>

      {/* Content */}
      {isExpanded && (
        <div className="px-3 py-3">
          <div className="space-y-2.5 text-xs text-gray-700 leading-relaxed">
            <div>
              <strong className="text-gray-900">1. 对问题的理解：</strong>
              <p className="mt-0.5 text-gray-600">
                用户希望了解最近一周的票务销售趋势，需要按日期统计每天的票务数量，以便分析业务增长情况和周期性规律。
              </p>
            </div>

            <div>
              <strong className="text-gray-900">2. 字段验证：</strong>
              <p className="mt-0.5 text-gray-600">
                检查票务系统表结构，确认存在 <code className="px-1 py-0.5 bg-gray-100 rounded text-xs">date</code> 字段（日期类型）和主键字段，可用于统计和分组。
              </p>
            </div>

            <div>
              <strong className="text-gray-900">3. 表和字段选择：</strong>
              <p className="mt-0.5 text-gray-600">
                选择 <code className="px-1 py-0.5 bg-gray-100 rounded text-xs">tickets</code> 表作为数据源，使用 <code className="px-1 py-0.5 bg-gray-100 rounded text-xs">date</code> 字段进行时间筛选和分组，通过 <code className="px-1 py-0.5 bg-gray-100 rounded text-xs">COUNT(*)</code> 统计每日票务数量。
              </p>
            </div>

            <div>
              <strong className="text-gray-900">4. 查询逻辑构建：</strong>
              <p className="mt-0.5 text-gray-600">
                使用 <code className="px-1 py-0.5 bg-gray-100 rounded text-xs">DATE_SUB</code> 函数获取最近7天的日期范围，通过 <code className="px-1 py-0.5 bg-gray-100 rounded text-xs">WHERE</code> 子句过滤数据，使用 <code className="px-1 py-0.5 bg-gray-100 rounded text-xs">GROUP BY</code> 按日期分组，最后按日期升序排序以展示时间趋势。
              </p>
            </div>

            <div>
              <strong className="text-gray-900">5. 最终 SQL 代码：</strong>
              <pre className="mt-1 p-2 bg-gray-900 text-gray-100 rounded-lg overflow-x-auto text-xs font-mono">
{`SELECT 
  date, 
  COUNT(*) as value 
FROM tickets 
WHERE date >= DATE_SUB(NOW(), INTERVAL 7 DAY) 
GROUP BY date 
ORDER BY date;`}
              </pre>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
